/* Swindo-tema — återställer den interaktivitet som försvann när Claude Designs
   React-tillstånd plattades ut till statisk HTML.
   Två saker är bundna: dragspelen och galleriets miniatyrer.
   Variantväljaren och köpknappen är INTE bundna — de kräver att produkten
   finns i Shopify. Se FAKTASVEP.md. */
(function () {
  'use strict';

  function isToggle(btn) {
    var last = btn.lastElementChild;
    if (!last) return false;
    var t = (last.textContent || '').trim();
    return t === '+' || t === '−' || t === '-';
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest ? e.target.closest('button') : null;
    if (!btn) return;

    /* dragspel */
    if (isToggle(btn)) {
      var body = btn.nextElementSibling;
      if (body) {
        var open = body.style.display !== 'none';
        body.style.display = open ? 'none' : '';
        var sign = btn.lastElementChild;
        sign.textContent = open ? '+' : '−';
        sign.style.transform = open ? 'rotate(0deg)' : 'rotate(180deg)';
      }
      e.preventDefault();
      return;
    }

    /* Galleriets miniatyrer. På dator tonar lagren över varandra som i
       designen. På mobil är scenen en svepkarusell (CSS scroll-snap), och då
       ska klicket rulla dit i stället — annars byter inget synligt, vilket var
       precis felet Ludvig såg. */
    var thumb = e.target.closest ? e.target.closest('[data-thumb]') : null;
    if (thumb) {
      var num = parseInt(thumb.getAttribute('data-thumb'), 10);
      var first = document.getElementById('gal-1');
      if (!first) return;
      var scen = first.parentElement.parentElement;
      var lager = scen.children;
      var mobil = window.matchMedia('(max-width: 749px)').matches;

      if (mobil && lager[num - 1]) {
        lager[num - 1].scrollIntoView({ inline: 'center', block: 'nearest', behavior: 'smooth' });
      } else {
        for (var i = 0; i < lager.length; i++) {
          var on = (i === num - 1);
          lager[i].style.opacity = on ? '1' : '0';
          lager[i].style.zIndex = on ? '2' : '1';
          lager[i].style.pointerEvents = on ? 'auto' : 'none';
        }
      }
      var all = document.querySelectorAll('[data-thumb]');
      for (var k = 0; k < all.length; k++) all[k].classList.toggle('is-on', all[k] === thumb);
      e.preventDefault();
    }
  });
})();

/* Produktkorten i den importerade designen är rena div:ar — Claude Design känner
   inte butikens adresser. Här kopplas de: varje kort vars rubriktext exakt matchar
   en produkttitel i butiken blir klickbart och pekar på rätt produktsida.
   Kartan kommer från Liquid i layouten, så den följer sortimentet automatiskt. */
(function () {
  'use strict';
  var el = document.getElementById('sw-product-map');
  if (!el) return;
  var map;
  try { map = JSON.parse(el.textContent); } catch (e) { return; }
  if (!map || !map.length) return;

  /* Designen skriver "Swindo FastDry – Köksduk" med tankstreck, Shopify med
     bindestreck. Normalisera bort skiljetecken innan jämförelsen, annars
     matchar bara hälften av korten. */
  function norm(s) {
    return (s || '').toLowerCase()
      .replace(/[\u2010-\u2015\u2212]/g, '-')
      .replace(/[^a-z0-9åäöæø]+/g, ' ')
      .trim();
  }
  var byTitle = {};
  map.forEach(function (p) { byTitle[norm(p.t)] = p.u; });

  function cardFor(node) {
    /* närmaste förälder som ser ut som ett kort: har radie eller ram */
    var n = node, hops = 0;
    while (n && n !== document.body && hops < 6) {
      var cs = getComputedStyle(n);
      if (parseFloat(cs.borderRadius) >= 8 && n.getBoundingClientRect().height > 120) return n;
      n = n.parentElement; hops++;
    }
    return null;
  }

  var wired = 0;
  document.querySelectorAll('main *, .shopify-section *').forEach(function (n) {
    if (n.children.length) return;
    if (n.closest('a')) return;
    var url = byTitle[norm(n.textContent)];
    if (!url) return;
    var card = cardFor(n);
    if (!card || card.dataset.swLinked) return;
    card.dataset.swLinked = '1';
    card.style.cursor = 'pointer';
    card.addEventListener('click', function (e) {
      if (e.target.closest('button')) return;
      location.href = url;
    });
    wired++;
  });
  if (window.console && wired) console.log('[swindo] produktkort kopplade:', wired);
})();

/* Kjøpsblokken. Claude Design tegnet variantvelgeren og knappen, men kjente
   ingen variant-ID-er — de kommer fra Liquid i #sw-dusjnal.
   Knappen sender et EKTE skjema til /cart/add, ikke et fetch-kall. Grunnen er
   målt tidligere: Shopifys AJAX-endepunkt svarer med HTML ved feil, og en
   .json() på det svaret dreper kjøpsknappen uten et eneste synlig varsel. */
(function () {
  'use strict';
  var el = document.getElementById('sw-dusjnal');
  if (!el) return;
  var data;
  try { data = JSON.parse(el.textContent); } catch (e) { return; }
  if (!data.variants || !data.variants.length) return;

  var current = data.variants[0];

  function cardOf(node) {
    var n = node, hops = 0;
    while (n && n !== document.body && hops < 5) {
      var cs = getComputedStyle(n);
      if (parseFloat(cs.borderRadius) >= 8 && n.getBoundingClientRect().height > 44) return n;
      n = n.parentElement; hops++;
    }
    return null;
  }

  /* koble hvert variantkort mot sin variant, i den rekkefølgen de står */
  var cards = [];
  document.querySelectorAll('main *, .shopify-section *').forEach(function (n) {
    if (n.children.length) return;
    var t = (n.textContent || '').trim();
    var m = t.match(/^(\d+)\s*stk\.?$/i);
    if (!m) return;
    var v = data.variants.filter(function (x) { return x.title.replace(/\s|\./g, '').toLowerCase() === t.replace(/\s|\./g, '').toLowerCase(); })[0];
    if (!v) return;
    var card = cardOf(n);
    if (!card || card.dataset.swVariant) return;
    card.dataset.swVariant = v.id;
    card.style.cursor = 'pointer';
    cards.push({ el: card, v: v });
  });

  function select(v) {
    current = v;
    cards.forEach(function (c) {
      var on = String(c.v.id) === String(v.id);
      /* Literal, inte var(): outline-shorthanden resolverade till svart när
         variabeln lästes i det här scopet. Uppmätt på live-previewen. */
      c.el.style.outline = on ? '2px solid #1748A3' : '';
      c.el.style.outlineOffset = on ? '-2px' : '';
    });
    buttons.forEach(function (b) { b.textContent = 'Legg i handlekurv — ' + v.price; });
  }

  /* kjøpsknappene: teksten i designen begynner alltid med "Legg i handlekurv" */
  var buttons = [].slice.call(document.querySelectorAll('button'))
    .filter(function (b) { return /^legg i handlekurv/i.test((b.textContent || '').trim()); });

  /* Köpknappen ska öppna temats EGNA kundvagnslåda med sina appar och
     upsells — inte skicka besökaren till /cart. Ett formulär-POST gjorde
     precis det, och bytte i praktiken ut kundvagnen.

     Temat har <cart-drawer> med addItemToCart(variantId), samma metod dess
     egen sticky-knapp använder. Vi anropar den. Finns lådan inte kvar
     faller vi tillbaka på formuläret, så knappen aldrig blir död. */
  function läggIVagn(id, knapp) {
    var låda = document.querySelector('cart-drawer');
    if (låda && typeof låda.addItemToCart === 'function') {
      var text = knapp.textContent;
      knapp.disabled = true;
      Promise.resolve(låda.addItemToCart(id))
        .catch(function () { formulär(id); })
        .then(function () { knapp.disabled = false; knapp.textContent = text; });
      return;
    }
    formulär(id);
  }
  function formulär(id) {
    var f = document.createElement('form');
    f.method = 'post';
    f.action = '/cart/add';
    f.hidden = true;
    f.innerHTML = '<input name="id" value="' + id + '"><input name="quantity" value="1">';
    document.body.appendChild(f);
    f.submit();
  }

  buttons.forEach(function (b) {
    b.addEventListener('click', function (e) {
      e.preventDefault();
      läggIVagn(current.id, b);
    });
  });

  cards.forEach(function (c) {
    c.el.addEventListener('click', function () { select(c.v); });
  });
  if (cards.length) select(current);
  if (window.console) console.log('[swindo] variantkort:', cards.length, '· kjøpsknapper:', buttons.length);
})();


/* Sticky köprad — visas först när den riktiga köpknappen rullat ur bild.

   Två fel i första försöket, båda uppmätta live:
   1. Skriptet kördes innan sticky-raden fanns i DOM:en, trots defer, och
      returnerade tyst. Nu väntar det på DOMContentLoaded när det behövs.
   2. Ankaret plockades med en CSS-selektor som fastnade på en miniatyrknapp
      i stället för köpknappen. Nu matchas knappen på sin egen text.        */
(function () {
  'use strict';
  function start() {
    var bar = document.querySelector('.sw-stickybar');
    if (!bar) return;

    var knappar = [].slice.call(document.querySelectorAll('button, .product-form__submit, input[type=submit]'));
    var cta = knappar.filter(function (b) {
      var t = (b.textContent || b.value || '').trim();
      return /^(legg i handlekurv|lägg i kundvagn|lägg i varukorg|add to cart)/i.test(t) && !bar.contains(b);
    })[0];
    if (!cta) { bar.classList.add('is-visible'); return; }

    /* Villkoret är att knappen har rullat FÖRBI, inte att den är osynlig.
       På mobil ligger köpknappen under vikningen redan vid sidans topp — med
       "syns inte" hade raden legat framme direkt, vilket var hela felet. */
    function uppdatera() {
      bar.classList.toggle('is-visible', cta.getBoundingClientRect().bottom < 0);
    }
    /* Scrollyssnaren är inte överflödig: den täcker fallet då observern
       registreras efter att sidan redan är nedscrollad. */
    window.addEventListener('scroll', uppdatera, { passive: true });
    window.addEventListener('resize', uppdatera, { passive: true });
    uppdatera();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();

/* Videorna laddas först när de närmar sig vyn. Ludvig ville att allt ovanför
   Trustpilot-sektionen ska ligga först och resten komma efter.

   Utan detta hämtade webbläsaren båda filmerna direkt vid sidladdning, långt
   under folden. Nu bär de data-src och preload="none"; källan sätts 600 px
   innan rutan syns, och uppspelningen startar först när den faktiskt syns. */
(function () {
  'use strict';
  function start() {
    var vids = [].slice.call(document.querySelectorAll('video[data-src]'));
    if (!vids.length) return;

    function ladda(v) {
      if (v.dataset.laddad) return;
      v.dataset.laddad = '1';
      v.src = v.getAttribute('data-src');
      v.load();
    }
    if (!('IntersectionObserver' in window)) { vids.forEach(ladda); return; }

    var förladda = new IntersectionObserver(function (poster) {
      poster.forEach(function (p) { if (p.isIntersecting) { ladda(p.target); förladda.unobserve(p.target); } });
    }, { rootMargin: '600px 0px' });

    var spela = new IntersectionObserver(function (poster) {
      poster.forEach(function (p) {
        if (p.isIntersecting) { ladda(p.target); var q = p.target.play(); if (q && q.catch) q.catch(function () {}); }
        else if (!p.target.paused) { p.target.pause(); }
      });
    }, { threshold: 0.25 });

    vids.forEach(function (v) { förladda.observe(v); spela.observe(v); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();

/* Rom for rom-flikarna. De var attrapper: fyra knappar utan beteende.
   Nu visar varje flik sin egen kollektion. */
(function () {
  'use strict';
  function start() {
    var tabs = [].slice.call(document.querySelectorAll('.sw-tab'));
    if (!tabs.length) return;
    var paneler = [].slice.call(document.querySelectorAll('.sw-panel'));
    tabs.forEach(function (t) {
      t.addEventListener('click', function () {
        var rom = t.getAttribute('data-rom');
        tabs.forEach(function (x) {
          var på = x === t;
          x.classList.toggle('is-on', på);
          x.setAttribute('aria-selected', på ? 'true' : 'false');
        });
        paneler.forEach(function (p) {
          p.classList.toggle('is-on', p.getAttribute('data-panel') === rom);
        });
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();


/* Svep i galleriet ska markera rätt miniatyr. Ingen egen scroll-logik — CSS
   scroll-snap gör rörelsen, det här läser bara av var man hamnade. */
(function () {
  'use strict';
  function start() {
    var first = document.getElementById('gal-1');
    if (!first) return;
    var scen = first.parentElement.parentElement;
    var thumbs = [].slice.call(document.querySelectorAll('[data-thumb]'));
    if (!thumbs.length) return;
    var timer;
    scen.addEventListener('scroll', function () {
      clearTimeout(timer);
      timer = setTimeout(function () {
        if (!window.matchMedia('(max-width: 749px)').matches) return;
        var i = Math.round(scen.scrollLeft / scen.clientWidth);
        thumbs.forEach(function (t, k) { t.classList.toggle('is-on', k === i); });
      }, 90);
    }, { passive: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
